import { atom } from '@exodus/headless-ui';
import { WalletAccount } from '@exodus/models';
import fromAssetAtom from './from-asset.js';
const INITIAL_VALUE = WalletAccount.DEFAULT_NAME;
const fromWalletAccountNameAtom = atom(INITIAL_VALUE);
const fromWalletAccountAtom = atom((get, { selectors }) => {
    const getWalletAccount = get(selectors.walletAccounts.get);
    const activeWalletAccountName = get(selectors.walletAccounts.active);
    const activeWalletAccount = getWalletAccount(activeWalletAccountName);
    const fromWalletAccountName = get(fromWalletAccountNameAtom);
    const fromWalletAccount = getWalletAccount(fromWalletAccountName);
    return fromWalletAccount || activeWalletAccount || WalletAccount.DEFAULT;
}, (get, set, walletAccount, { selectors }) => {
    const newWalletAccountName = walletAccount?.toString() ?? INITIAL_VALUE;
    set(fromWalletAccountNameAtom, newWalletAccountName);
    const fromAsset = get(fromAssetAtom);
    const assetsByWalletAccounts = get(selectors.assetSources.availableAssetNamesByWalletAccount);
    const assetsInWalletAccount = assetsByWalletAccounts[newWalletAccountName];
    if (assetsInWalletAccount && !assetsInWalletAccount.has(fromAsset.name)) {
        set(fromAssetAtom, undefined);
    }
});
export default fromWalletAccountAtom;
